import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Nav from "../common/Nav";
import Abouthero from "../Abouthero";
import OurValue from "../OurValue";
import Awards from "../Awards";
import Footer from "../common/Footer";
import CoverStory from "../CoverStory";
import AsiaBusiness from "../AsiaBusiness";

const About = () => {
  const { pathname } = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <>
      <Nav />
      <main className="overflow-hidden">
        <Abouthero />
        <OurValue />
        <CoverStory />
        <AsiaBusiness />
        <Awards />
      </main>
      <Footer />
    </>
  );
};

export default About;
